<template>
  <span
    v-if="validationOutput.error"
    class="text-sm"
    :class="{ 'text-warning': validationOutput.error }"
  >
    {{ validationOutput.message }}
    <slot />
  </span>
</template>

<script>
import { Validation } from "../validations/Validation";

export default {
  name: "Validation",
  data() {
    return {};
  },
  props: {
    validation: {
      default: null,
      type: Object
    },
    input: {
      default: null,
      type: String
    },
    focused: {
      default: false,
      type: Boolean
    }
  },
  components: {},
  methods: {},
  computed: {
    validationOutput() {
      if (!this.validation) return;
      let output = new Validation(this.validation, this.input).validate();

      return output;
    },
    computedFocused() {
      return this.focused;
    },
    validated() {
      return null;
    }
  },
  created() {}
};
</script>